<template>
    <!-- WHAT STANDS WHERE THE BUTTON WAS.
      --
      -- The primary button is v-show'n on `!workInFlight`, so from the moment
      -- Save is pressed it simply VANISHES -- the least informative thing a
      -- page can do at the one moment somebody is waiting. VideoProgress.vue
      -- records the same complaint and fixes it for a clip; this is the fix
      -- for every other page, and it is deliberately small: a clip is a
      -- full-screen panel because the work is long and the stage is gone,
      -- while here the picture is still on screen and only the button left.
      --
      -- The button is NOT kept visible-and-disabled instead, and that is not a
      -- style preference. Several browser suites use the button's absence as
      -- the signal that work is in flight -- tests/video_to_gif_test.sh waits
      -- for it to COME BACK before pressing Save a second time -- so a button
      -- that never goes away turns those waits into no-ops.
      --
      -- No new catalogue keys: result.uploading and result.working already
      -- exist in all ten, and they already name these two phases. -->
    <div class="flex items-center gap-3" role="status" aria-live="polite">
        <svg class="h-5 w-5 animate-spin text-brand" viewBox="0 0 48 48" fill="none" aria-hidden="true">
            <circle cx="24" cy="24" r="20" stroke="currentColor" stroke-width="4" class="opacity-20"></circle>
            <path d="M44 24a20 20 0 0 0-20-20" stroke="currentColor" stroke-width="4" stroke-linecap="round"></path>
        </svg>
        <span class="text-[15px] text-ink-soft">{{ label }}</span>
    </div>
</template>

<script setup>
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import { useUiElements } from "./../store/uiElements"

const { t } = useI18n()
const uiStore = useUiElements()

/* Two phases, and the visitor can tell them apart.
 *
 * `isUploading` is the bytes going up; everything after it is the CDN making
 * the versions and this side waiting for them. Reported as "the system may
 * need several seconds before the download is signaled by the device" -- the
 * second half is most of that wait, and it used to say nothing at all.
 */
const label = computed(() =>
    uiStore.isUploading ? t("result.uploading") : t("result.working"))
</script>
